import {decorate, observable} from 'mobx';
import {faBacon} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class Workflow extends BaseModel {
  static faIcon = faBacon;

  searchableProperties = ['name'];

  saveableProperties = ['name', 'info', 'properties'];

  static prepareApiPayload(model) {
    return {
      id: model.id || undefined,
      name: model.name || null,
      info: model.info || null,
      properties: model.properties || null,
    };
  }
}

decorate(Workflow, {
  id: observable,
  name: observable,
  info: observable,
  properties: observable,
  updatedAt: observable,
  updatedBy: observable,
  createdAt: observable,
  createdBy: observable,
});
